import { Cookies } from 'react-cookie';

import { Trap } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const updateTrap = async (info: { slug: string; trapId: number; trapInfo: Trap }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/object_traps_add_update/${info.slug}/${info.trapId}/`,
    {
      ...info.trapInfo,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
